import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const WorkIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M21.5 19.625a.902.902 0 0 1-.242.619.803.803 0 0 1-.584.256H3.326a.803.803 0 0 1-.584-.256.902.902 0 0 1-.242-.619V7.375c0-.232.087-.455.242-.619a.803.803 0 0 1 .584-.256h17.348c.219 0 .43.092.584.256a.902.902 0 0 1 .242.619v12.25ZM8 6.5 8.5 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5l.5 2.5M2.5 10.5h19"
            />
        </svg>
    </IconWrapper>
)
